// src/slices/wishlistSlice.js
import { createSlice } from '@reduxjs/toolkit';

const getStoredSlugs = () => {
  try {
    return JSON.parse(localStorage.getItem('wishlistSlugs')) || [];
  } catch (error) {
    console.error('Error loading wishlist slugs:', error);
    return [];
  }
};

const saveSlugs = (slugs) => {
  try {
    localStorage.setItem('wishlistSlugs', JSON.stringify(slugs));
  } catch (error) {
    console.error('Error saving wishlist slugs:', error);
  }
};

const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState: {
    wishlistSlugs: getStoredSlugs(),
  },
  reducers: {
    toggleWishlistProduct: (state, action) => {
      const slug = action.payload;
      const existingIndex = state.wishlistSlugs.indexOf(slug);

      if (existingIndex >= 0) {
        state.wishlistSlugs.splice(existingIndex, 1);
      } else {
        state.wishlistSlugs.push(slug);
      }

      saveSlugs(state.wishlistSlugs);
    },
    clearWishlist: (state) => {
      state.wishlistSlugs = [];
      localStorage.removeItem('wishlistSlugs');
    },
  },
});

export const { toggleWishlistProduct, clearWishlist } = wishlistSlice.actions;
export default wishlistSlice.reducer;